import PerformanceView from "@/components/PerformanceView";

export default function Performance() {
  return (
    <div className="space-y-5">
      <div>
        <div className="eyebrow">Growth · YoY · Quarterly · Monthly</div>
        <h1 className="mt-2 font-editorial font-light text-[34px] leading-[1.02] sm:text-4xl md:text-5xl text-slate-900 tracking-[-0.035em]" data-testid="performance-title">
          <em className="italic">Performance.</em>
        </h1>
        <p className="mt-2 text-sm text-slate-500 max-w-lg">
          How each investment has performed — year-on-year, quarter-on-quarter, month-on-month.
        </p>
      </div>
      <PerformanceView defaultPeriod="yoy" />
    </div>
  );
}
